import React from 'react';

import LockIcon from '@mui/icons-material/Lock';
import { Box, Grid, IconButton } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { ReactHookFormIntlNumberInput } from 'common/components/form';
import TitleWithDetail from 'common/components/TitleWithDetail';

import * as actions from '../actions';
import * as selectors from '../selectors';

import EditPermissionsModal from './EditPermissionsModal';

const TabComissions = ({ control, getValues, disabled, setValue }) => {
    const { t } = useTranslation();

    const handleOnHide = () => openEmailModal(false);

    const dispatch = useDispatch();
    const initializeAuthEmailsForm = (values) =>
        dispatch(actions.initializeAuthEmailsForm(values));
    const openEmailModal = (value) => dispatch(actions.openEmailModal(value));

    const isOpenEmailsModal = useSelector(selectors.getIsOpenEmailsModal);

    const handleSaveEmails = ({ auth_emails }) => {
        setValue('commision_configs[1].auth_emails', auth_emails);
        openEmailModal(false);
    };

    return (
        <>
            <Box sx={{ mb: 2 }}>
                <TitleWithDetail variant="body2">
                    {t('External')}
                </TitleWithDetail>
            </Box>

            <Grid container>
                <Grid size={{ md: 9, xs: 18 }}>
                    <ReactHookFormIntlNumberInput
                        allowNegativeValue={false}
                        append="%"
                        control={control}
                        disabled={disabled}
                        fullWidth
                        label="FV"
                        min={0}
                        name="commision_configs[0].fv_percentage"
                        step="any"
                    />
                </Grid>
                <Grid size={{ md: 9, xs: 18 }}>
                    <ReactHookFormIntlNumberInput
                        allowNegativeValue={false}
                        append="%"
                        control={control}
                        disabled={disabled}
                        fullWidth
                        label="BESS"
                        min={0}
                        name="commision_configs[0].bess_percentage"
                        step="any"
                    />
                </Grid>
            </Grid>

            <Box alignItems="center" display="flex" sx={{ mb: 2, mt: 3 }}>
                <TitleWithDetail variant="body2">
                    {t('Internal')} ({t('Protected', { context: 'female' })})
                </TitleWithDetail>
                <IconButton
                    disabled={disabled}
                    onClick={() => {
                        initializeAuthEmailsForm({
                            auth_emails: getValues(
                                'commision_configs[1].auth_emails',
                            ),
                        });
                        openEmailModal(true);
                    }}
                >
                    <LockIcon fontSize="small" />
                </IconButton>
            </Box>

            <Grid container>
                <Grid size={{ md: 9, xs: 18 }}>
                    <ReactHookFormIntlNumberInput
                        allowNegativeValue={false}
                        append="%"
                        control={control}
                        disabled={disabled}
                        fullWidth
                        label="FV"
                        min={0}
                        name="commision_configs[1].fv_percentage"
                        step="any"
                    />
                </Grid>
                <Grid size={{ md: 9, xs: 18 }}>
                    <ReactHookFormIntlNumberInput
                        allowNegativeValue={false}
                        append="%"
                        control={control}
                        disabled={disabled}
                        fullWidth
                        label="BESS"
                        min={0}
                        name="commision_configs[1].bess_percentage"
                        step="any"
                    />
                </Grid>
            </Grid>

            <EditPermissionsModal
                callback={handleSaveEmails}
                isOpen={isOpenEmailsModal}
                onHide={handleOnHide}
            />
        </>
    );
};

TabComissions.propTypes = {
    control: PropTypes.object,
    disabled: PropTypes.bool,
    getValues: PropTypes.func,
    setValue: PropTypes.func,
};

export default TabComissions;
